import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { FatalError } from '$app-web/utils';

import { Locales } from './locales';

let initialized = false;

export function initializeAppDateTime() {
    if (!initialized) {
        dayjs.extend(LocalizedFormat);
        dayjs.extend(utc);
        dayjs.extend(timezone);
        dayjs.extend(customParseFormat);
        dayjs.extend(relativeTime);
        dayjs.extend(advancedFormat);
        Locales.forEach(([locale, localeData]) => {
            dayjs.locale(locale, localeData);
        });
        initialized = true;
    }
}

export function changeAppDateTimeLocale(code: string) {
    if (!initialized) {
        throw new FatalError('You should initialize dateTime.core before calling changeLocale.');
    }
    dayjs.locale(code);
}
